<mat-toolbar>
  <div class="left">
    <img class="mood-logo" alt="MOOD" src="assets/images/logo_mood.png" />
    <img class="geoai-logo" alt="GeoAI4EI" src="assets/images/logo_geoai4ei.svg" />
  </div>

  <div class="middle"></div>

  <div class="right">
    <button mat-raised-button [matMenuTriggerFor]="toolsMenu" class="tools-button">
      <!-- <mat-icon svgIcon="widgets"></mat-icon> -->
      <span>Modules</span>
    </button>

    <button
      mat-raised-button
      [matMenuTriggerFor]="geonetworkCategoriesMenu"
      [matMenuTriggerData]="{ categories: toolEntries }"
      class="tools-button"
    >
      <!-- <mat-icon svgIcon="forward"></mat-icon> -->
      <span>Tools</span>
    </button>

    <button
      mat-raised-button
      [matMenuTriggerFor]="geonetworkCategoriesMenu"
      [matMenuTriggerData]="{ categories: codeEntries }"
      class="tools-button"
    >
      <!-- <mat-icon svgIcon="forward"></mat-icon> -->
      <span>Code</span>
    </button>

    <button mat-raised-button class="tools-button" (click)="openAboutDialog()">
      <span>About</span>
    </button>
  </div>
</mat-toolbar>

<mat-menu #geonetworkToolsMenu="matMenu">
  <ng-template matMenuContent let-tools="tools">
    <ng-container *ngFor="let tool of tools; let last = last">
      <div mat-menu-item (click)="onGeonetworkToolClicked(tool)">
        <h4 class="tool-label">{{ tool.title }}</h4>
        <sub class="sub-text">{{ tool.abstract }}</sub>
      </div>
      <mat-divider class="menu-divider" *ngIf="!last"></mat-divider>
    </ng-container>
  </ng-template>
</mat-menu>

<mat-menu #toolsMenu="matMenu">
  @for (tool of tools; track $index) {
    <button mat-menu-item (click)="onToolClicked(tool)">{{ tool.label }}</button>
  }
</mat-menu>

<mat-menu #geonetworkCategoriesMenu="matMenu">
  <ng-template matMenuContent let-categories="categories">
    <ng-container *ngFor="let category of categories">
      <button mat-menu-item [matMenuTriggerFor]="geonetworkToolsMenu" [matMenuTriggerData]="{ tools: category.tools }">
        {{ category.label }}
      </button>
    </ng-container>
  </ng-template>
</mat-menu>
